import styled from 'styled-components';

export const ProductListContainer = styled.div`
  padding: 20px;
  background-color: ${(props) => props.theme.colors.white};
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e5e5e5;
`;

export const ResultCount = styled.div`
  font-family: ${(props) => props.theme.fontFamilies?.openSans};
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.colors.darkGrey};
`;

export const PaginationContainer = styled.div`
  margin-top: 30px;
`;

export const EmptyResults = styled.div`
  text-align: center;
  padding: 40px 0;
  color: #666;
`;

export const ProductsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
  margin-top: 20px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  }
`;

// Custom wrapper to intercept clicks completely
export const ProductCardWrapper = styled.div`
  cursor: pointer;
  position: relative;

  /* Create a transparent overlay to capture all clicks */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }

  /* Completely disable all pointer events on child elements */
  * {
    pointer-events: none !important;
  }
`;
